export const iconFromType = {
  length: 'mdi-ruler',
  area: 'mdi-ruler-square',
  volume: 'mdi-cube-outline',
  weight: 'mdi-weight',
  count: 'mdi-chart-bubble',
  custom: 'mdi-chart-bubble'
}
